module.exports = __webpack_public_path__ + "static/media/quindio-41.6d577ee7.jpg";